export const LogoMark = ({ size = 32, className = "" }) => (
  <img src="/img/logo.png" alt="" width={size} height={size} className={`rounded-lg ${className}`} />
);

export const Wordmark = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark size={32} />
    <span className="font-display text-lg sm:text-xl font-extrabold uppercase tracking-wide leading-none">
      Angler<span className="text-[#00E5FF]">League</span>
    </span>
  </span>
);
